<frontend-header><frontend-header-back-btn></frontend-header-back-btn></frontend-header>

<frontend-check-in [state]="state$ | async" (save)="onSave($event)"></frontend-check-in>
